export default __webpack_public_path__ + "static/lframe-calculator-personal-loan-repayment-5a8102f4aa2602c0dd5c8549683ecc3d.webp";